import { z } from 'zod';
// Note: z.discriminatedUnion in Zod 3 requires ZodObject discriminants.
// .refine() returns ZodEffects which cannot be used in discriminatedUnion.
// We use z.union with refined shapes instead.
const adminPatchShape = z
    .object({
    kind: z.literal('admin'),
    scope: z.enum(['all', 'specific']).optional(),
    accessibleOrgIds: z.array(z.string().uuid()).optional(),
})
    .strict()
    .refine((data) => data.scope !== undefined || data.accessibleOrgIds !== undefined, { message: 'empty_update: at least one of scope or accessibleOrgIds must be provided' })
    .refine((data) => {
    // F-2 (codex final review): if scope='specific' is being mutated, the
    // payload MUST also carry a non-empty accessibleOrgIds. A patch that
    // sets scope='specific' without orgs would leave the membership in an
    // application-invalid state (membership.orgs would be inherited from
    // the existing aggregate's set; if that set is also empty the entity
    // accepts but every UC rejects). Catch at the schema boundary so the
    // 422 carries the structured `specific_scope_requires_at_least_one_org`
    // token instead of falling through to the UC's
    // EmptyOrgsForSpecificScopeError mapping.
    if (data.scope !== 'specific') {
        return true;
    }
    return Array.isArray(data.accessibleOrgIds) && data.accessibleOrgIds.length > 0;
}, { message: 'specific_scope_requires_at_least_one_org' });
const memberPatchShape = z
    .object({
    kind: z.literal('member'),
    roleId: z.string().uuid().optional(),
})
    .strict()
    .refine((data) => data.roleId !== undefined, {
    message: 'empty_update: roleId is required for member patch',
});
export const updateGroupMemberSchema = z.union([adminPatchShape, memberPatchShape]);
//# sourceMappingURL=update-group-member.schema.js.map